import React, {ComponentType} from "react";
import { IHandlers, classPrefix, IProps, IContainerProps, IFlagPhonePicker, IBaseProps} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import FlagPhonePickerValidationHelper from 'external-components/flag-phone-picker-react/FlagPhonePickerValidationHelper';

const NS = 'FlagPhonePickerContainer';

const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const propsKeys: string[] = keys<IProps>();

const ThemeWrap = function(all: IFlagPhonePicker) {

  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;
  props.classPrefix = classPrefix;
  /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
  }
  return ReactUtilsService.containerWrap(
    <FlagPhonePickerValidationHelper {...props} {...handlers}/>, classPrefix
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AFlagPhonePicker: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[]
];
